<template>
  <div class="payment-container">
    <div class="input-title">결제 금액</div>
    <div class="option-border"></div>
    <div class="pay-block">
      <div class="pay-title" :style="{ flex: 1 }">주문 금액</div>
      <div class="pay-content" :style="{ flex: 2 }">{{ this.setPrice1 }} 원</div>
    </div>
    <div class="pay-block">
      <div class="pay-title" :style="{ flex: 1 }">할인 금액</div>
      <div class="pay-content" :style="{ flex: 2 }">{{ this.discountedPrice }} 원</div>
    </div>
    <div class="pay-block">
      <div class="pay-title" :style="{ flex: 1 }">쿠폰/적립금 할인</div>
      <div class="pay-content" :style="{ flex: 2 }">{{ this.setPrice2 }} 원</div>
    </div>
    <div class="option-border"></div>
    <div class="pay-block">
      <div class="pay-title" :style="{ flex: 1 }">총 결제금액</div>
      <div class="pay-content-bold" :style="{ flex: 2 }">{{ this.setPrice3 }} 원</div>
    </div>

  </div>
</template>
<script>
import store from '@/store';
export default {
  data() {
    return{
      discountedPrice: store.state.surveyOption.priceDiscounted
    }
  },
  computed : {
    setPrice1(){
      return store.state.surveyOption.price + store.state.surveyOption.priceDiscounted
    },
    setPrice2(){
      console.log(store.state.surveyOption.coupon, store.state.surveyOption.point)
      return (store.state.surveyOption.coupon + store.state.surveyOption.point)
    },
    setPrice3(){
      return store.state.surveyOption.price - (store.state.surveyOption.coupon + store.state.surveyOption.point)
    }
  },
  method : {
    priceToString(price) {
      return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
  }

}
</script>

<style scoped>
.payment-container {
  display: flex;
  flex-direction: column;
  font-family: var(--font-sans);
  text-align: left;
  max-width: 552px;
  margin: 24px auto;
  padding: 24px;
  box-sizing: border-box;
  background-color: var(--surface-card);
  border: 1px solid var(--ink-100);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-md);
}

.input-title{
  font-size: 18px;
  font-weight: var(--font-weight-semibold);
  color: var(--ink-900);
}

.option-border{
  border-top: 1px solid var(--ink-200);
  margin-top: 14px;
}

.pay-block {
  margin-top: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
}

.pay-warn {
  text-align: left;
  color: var(--ink-400);
  font-size: 12px;
  font-weight: var(--font-weight-regular);
  margin-top: 10px;
}

.pay-title {
  text-align: left;
  margin-right: 24px;
  color: var(--ink-500);
  font-size: 14px;
  font-weight: var(--font-weight-regular);
}
.pay-content-bold{
  text-align: left;
  font-size: 18px;
  color: var(--green-500);
  font-weight: var(--font-weight-bold);
}
.pay-content{
  text-align: left;
  font-size: 14px;
  color: var(--ink-800);
  font-weight: var(--font-weight-medium);
}
</style>